var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { action, observable } from 'mobx';
import { timer } from 'rxjs';
import { EnumAPI } from '../../apis';
import { BaseModel } from '../../libraries';
import { AjaxBasics } from './../../libraries';
import { WebSocket } from './socket';
import { createUserModel } from './userInfo';
export class ProductController {
    constructor() {
        this.Model = new BaseModel({ type: 'object' });
        this.liveProductList = [];
        //用户数据
        this.UserInfo = createUserModel();
    }
    createWebsocket() {
        this.webSocket = new WebSocket('/livews/subscribe', 'PRODUCT');
        this.webSocket.observable.subscribe((msg) => this.onSocketReceived(msg), //每当有来自服务器的消息时调用。
        (err) => this.onSocketError(err), // 调用如果在任何点WebSocket API信号某种错误
        () => this.onSocketComplete());
    }
    connectWebsocket() {
        if (this.connectTimer) {
            this.connectTimer.unsubscribe();
        }
        this.connectTimer = timer(5000).subscribe(() => {
            this.createWebsocket();
        });
    }
    onSetState(name, value) {
        this[name] = value;
    }
    /**
     * 获取直播间产品列表
     * @returns
     */
    async getLiveProductList() {
        try {
            const res = await AjaxBasics.request(lodash.assign(EnumAPI.live_product_list, {
                body: { liveId: this.UserInfo.liveId },
            }));
            this.onSetState('liveProductList', res ? res : []);
        }
        catch (error) { }
    }
    onSocketReceived(msg) {
        if (msg.code == '00000') {
            // this.onSetState('liveProductList', msg.data ? msg.data : []);
        }
    }
    onSocketComplete() {
        this.connectWebsocket();
    }
    onSocketError(err) {
        console.log(err, ' onSocket err');
    }
}
__decorate([
    observable
], ProductController.prototype, "liveProductList", void 0);
__decorate([
    action.bound
], ProductController.prototype, "onSetState", null);
